{
  "add": "Add",
  "addPeople": "Add people",
  "addTo": "Add to {{group}}",
  "allowedBy": {
    "administrators": "an administrator",
    "every_signed_in_person": "everyone signed in",
    "item_curator": "curator of an item"
  },
  "alwaysLast": "always last",
  "alwaysOnTop": "always on top",
  "atTop": "At the top level",
  "blocks": {
    "dmw_core": "DMW's own project",
    "not_deletable": "can't be deleted",
    "project_not_active": "project not active"
  },
  "breadcrumb": "Where you are",
  "categories": {
    "agents": "Agents",
    "content": "Content",
    "curation": "Curation",
    "inProjects": "In every project that includes this group",
    "installation": "In the installation",
    "management": "Management",
    "releases": "Data releases"
  },
  "chips": {
    "curateEvery": "Curate every kind",
    "curateOne": "Curate {{kind}}",
    "curateSome_one": "Curate {{count}} kind",
    "curateSome_other": "Curate {{count}} kinds",
    "everything": "Every installation permission",
    "everythingOf": "everything {{group}} has",
    "inProjects": "in projects:",
    "offHere": "off here:",
    "onHere": "here also:"
  },
  "create": "Create",
  "delete": "Delete",
  "deleteExplained": "Its members lose what it gives here.",
  "deleteInstallationExplained": "Its members lose what it gives, and every project that includes it loses it.",
  "deleteTitle": "Delete {{group}}?",
  "done": {
    "changed": "Saved {{group}}.",
    "excluded": "{{group}} is no longer included here.",
    "grantOff": "{{group}} can no longer: {{permission}}.",
    "grantOn": "{{group}} can now: {{permission}}.",
    "grants": "Changed what {{group}} allows.",
    "included": "{{group}} is included here.",
    "memberAdded": "{{name}} is in {{group}}.",
    "memberRemoved": "{{name}} is no longer in {{group}}.",
    "moved": "Moved {{group}}.",
    "overrides": "Changed what {{group}} gives here."
  },
  "everyoneWithAccount": "everyone with an account",
  "findPerson": "Find a person",
  "fromInstallation": "From the installation",
  "giveOnlyOwn": "You can give only permissions you have yourself; curating, anyone who manages the group.",
  "group": "Group",
  "groupGone": "This group no longer exists.",
  "groupMenu": "More for {{group}}",
  "groups": "Groups",
  "included": {
    "given": "Given here",
    "inherit": "As the installation",
    "notGiven": "Not given here",
    "off": "Off here",
    "on": "On here"
  },
  "includedHere": "included here",
  "inside": "Inside",
  "installationBadge": "installation",
  "invite": {
    "addresses": "Email addresses",
    "button": "Invite",
    "joins": "They join {{groups}} when they accept. No approval needed.",
    "joinsIn": "They join {{group}} in {{project}} when they accept. No approval needed.",
    "joinsNothing": "They get an account when they accept. No approval needed.",
    "people": "Invite people",
    "removeAddress": "Remove {{address}}",
    "send_one": "Send {{count}} invitation",
    "send_other": "Send {{count}} invitations",
    "title": "Invite to {{group}}"
  },
  "itemCurator_one": "Curates {{count}} item",
  "itemCurator_other": "Curates {{count}} items",
  "kind": {"installation": "Installation group", "project": "This project's group"},
  "kinds": {
    "every": "Every kind",
    "save": "Save",
    "title": "What {{group}} curates",
    "titleHere": "What {{group}} curates here"
  },
  "locked": "Can't be changed here",
  "members": "Members",
  "membersInAdministration": "Its members are managed in Administration.",
  "moveAbove": "Move above",
  "name": "Name",
  "newGroup": "New group",
  "newGroupButton": "+ New group",
  "newGroupItem": "New group…",
  "noMembers": "Nobody yet.",
  "nobody": "Nobody found.",
  "panel": {
    "close": "Close",
    "curates": "Curate {{kinds}}",
    "groupsHere": "Groups here",
    "haveIt_one": "Granted by {{groups}}",
    "haveIt_other": "Granted by {{groups}}",
    "here": "{{group}}, here",
    "inThisProject": "In this project",
    "inactive": "Can't sign in",
    "managedByAdministrators": "Administrators can change this access.",
    "managedBy_one": "{{names}} can change this access.",
    "managedBy_other": "{{names}} can change this access.",
    "no": "No:",
    "noGroup": "In no group here",
    "notOtherKinds_one": "not the other kind",
    "notOtherKinds_other": "not the other {{count}} kinds",
    "yes": "Yes:"
  },
  "people": "People",
  "peopleCount_one": "{{count}} person",
  "peopleCount_other": "{{count}} people",
  "permissions": {
    "change_installation": "Change installation settings",
    "change_rules": "Change the project's rules",
    "create_projects": "Create projects",
    "curate": "Curate: merge, send back or scrap",
    "delete_project": "Delete the project",
    "manage_accounts": "Manage accounts and groups below your highest group",
    "manage_people": "Manage people and groups below your highest group",
    "manage_server_keys": "Manage server keys and budgets",
    "propose": "Propose changes",
    "release": "Make and publish data releases",
    "restore_projects": "Restore and purge deleted projects",
    "server_keys": "Run agents on the server's API keys",
    "view": "View, comment and clone"
  },
  "permissionsTitle": "Permissions",
  "position_ordinal_few": "{{count}}rd of {{total}}",
  "position_ordinal_one": "{{count}}st of {{total}}",
  "position_ordinal_other": "{{count}}th of {{total}}",
  "position_ordinal_two": "{{count}}nd of {{total}}",
  "reason": {
    "confirm": "Switch on",
    "serverKeys": "Why may {{group}} run agents on the server's API keys?",
    "serverKeysHere": "Why may {{group}} run agents on the server's API keys here?"
  },
  "removeHere": "Remove from this project",
  "removeHereExplained": "Its members lose what it gives here. The group stays in the installation.",
  "removeHereTitle": "Remove {{group}} from this project?",
  "removedGroup": "A removed group",
  "rename": "Rename",
  "renameTitle": "Rename {{group}}",
  "requests": {
    "adds": "adds {{grants}}",
    "asks": "asks for “{{permission}}”",
    "decline": "Decline",
    "otherGroups": "Other groups",
    "reason": "“{{reason}}”",
    "title": "Requests for access"
  },
  "rule": "People may do whatever any of their groups allows; the order only decides who manages whom: managers manage the groups below their highest one.",
  "save": "Save",
  "serverKeysHint": "Only those who manage server keys give this, with a reason",
  "short": {
    "change_installation": "Settings",
    "change_rules": "Rules",
    "create_projects": "Create projects",
    "curate": "Curate",
    "delete_project": "Delete",
    "manage_accounts": "Accounts",
    "manage_people": "Manage",
    "manage_server_keys": "Key budgets",
    "propose": "Propose",
    "release": "Data releases",
    "restore_projects": "Deleted projects",
    "server_keys": "Server keys",
    "view": "View"
  },
  "startsEmpty": "Nothing yet",
  "startsLike": "Starts with what this group allows",
  "systemGroups": {
    "administrators": "Administrators",
    "contributors": "Contributors",
    "curators": "Curators",
    "everyone": "Everyone",
    "project_administrators": "Administrators",
    "readers": "Readers"
  },
  "takeOut": "Take {{name}} out of {{group}}",
  "undo": "Undo",
  "via": "via {{group}}",
  "view": "Show"
}
